import { render, staticRenderFns } from "./CollateralSelector.vue?vue&type=template&id=275a73f2&scoped=true&"
import script from "./CollateralSelector.vue?vue&type=script&lang=js&"
export * from "./CollateralSelector.vue?vue&type=script&lang=js&"
import style0 from "./CollateralSelector.vue?vue&type=style&index=0&id=275a73f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a73f2",
  null
  
)

export default component.exports